import {configureStore} from "@reduxjs/toolkit";
import orderReducer from "./components/order/OrderSlice";

export default configureStore({
    reducer: {
        order: orderReducer,
    },
})
